import styled from '@emotion/styled'
import { FunctionComponent, ReactNode } from 'react'
import { Colors } from '~/assets/style/colors'
import Button from '~/components/Button'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { PageContent } from '~/components/PageContent'
import { TabProp, Tabs } from '~/components/Tabs'
import { PureSiteStackHelpFlyout } from './PureSiteStackHelpFlyout'

const ContentWrapper = styled.div`
  margin-top: 20px;
`

type PureSitePageProps = {
  breadcrumbs?: ReactNode
  tabs: TabProp[]
  onTabChange: (tab: TabProp) => void
  children?: ReactNode | ReactNode[]
}
export const PureSitePage: FunctionComponent<PureSitePageProps> = ({ breadcrumbs, tabs, onTabChange, children }) => {
  const flyout = useGlobalFlyout()
  return (
    <PageContent
      breadcrumbs={breadcrumbs}
      headerActions={
        <Button
          variant={'tertiary'}
          iconName={'help'}
          onClick={() => flyout.open(PureSiteStackHelpFlyout, { color: Colors.Lilac, width: `612px`, closeTrackingLabel: 'adm-sites-help-close' })}
          trackingLabel={'adm-sites-activation-help'}
        >
          Help
        </Button>
      }
    >
      <Tabs tabs={tabs} onClick={onTabChange} />
      <ContentWrapper>{children}</ContentWrapper>
    </PageContent>
  )
}
